'use strict';
const angular = require('angular');

export class ntaSectionComponent {

  constructor(TaskService, HistoryService, prompt, dialogs, $uibModal, Auth) {
    'ngInject';
    this.$uibModal = $uibModal;
    this.prompt = prompt;
    this.dialogs = dialogs;
    this.Auth = Auth;

    this.TaskService = TaskService;
    this.HistoryService = HistoryService;

    this.dropdownMenu = [{
      icon: 'list',
      title: 'Add New Note',
      action: _ => {
        this.addNote();
      }
    },{
      icon: 'sticky-note',
      title: 'Add New Task',
      action: _ => {
        this.createTask();
      }
    }];
  }

  getUsername(note) {
    if (!note.meta.creationUser)
      return "-";

    let name = note.meta.creationUser.firstName;
    if (note.meta.creationUser.middleName)
      name += " " + note.meta.creationUser.middleName.substr(0,1) + ".";
    name += " " + note.meta.creationUser.lastName;

    return name;
  }

  $onInit() {
    this.TaskService.getByContext({id: this.contextId}, tasks => {
      this.tasks = tasks;
    });

    this.HistoryService.getByEntity({id: this.contextId}, activities => {
      this.activities = activities;
    });
  };

  refreshHook() {
    this.onRefresh();

    this.HistoryService.getByEntity({id: this.contextId}, activities => {
      this.activities = activities;
    });
  }

  createTask() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'taskEdit',
      resolve: {
        config: function() {
          return {
            context: {
              type: that.context,
              reference: that.contextId
            }
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (task) {
        that.TaskService.getByContext({id: that.contextId}, tasks => {
          that.tasks = tasks;
        });
      },
      function () { /* cancel */ }
    );

  }

  editTask(task) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'taskEdit',
      resolve: {
        config: function() {
          return {
            data: task
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (task) {
        that.TaskService.getByContext({id: that.contextId}, tasks => {
          that.tasks = tasks;
        });
      },
      function () { /* cancel */ }
    );

  }

  deleteTask(task) {
    var dlg = this.dialogs.confirm("Delete Task?", "Do you really want to delete this task?<br/><br/>" + task.subject);
    dlg.result.then(() => {
      this.TaskService.delete({id: task._id}, _ => {

        this.TaskService.getByContext({id: this.contextId}, tasks => {
          this.tasks = tasks;
        });

      });
    });
  }

  showTask(task) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'taskShow',
      resolve: {
        config: function() {
          return {
            data: task
          }
        }
      },
      size: 'md'
    });
  }

  addNote() {
    this.prompt({
      title: 'Add Note',
      message: 'Add your note below',
      input: true,
      label: '',
      value: ''
    }).then(note => {

      let noteObj = {
        meta: {
          creationUser: this.Auth.getCurrentUserSync()._id
        },
        note: note
      };

      this.service.patch({id: this.contextId}, [
        { "op": "add", "path": "/notes/-", "value": noteObj },
      ], data => {
        this.refreshHook();
      });
    });
  }

  deleteNote(idx) {
    var dlg = this.dialogs.confirm("Delete Note?", "Do you really want to delete this note?<br/><br/>" + this.data.notes[idx].note);
    dlg.result.then(() => {
      this.service.patch({id: this.contextId}, [
        { "op": "remove", "path": "/notes/"+idx },
      ], data => {
        this.data.notes.splice(idx,1);
      });
    },() => {
    });
  }

}

export default angular.module('conduuApp.ntaSection', [])
  .component('ntaSection', {
    template: require('./nta-section.component.html'),
    bindings: {
      context: '@',
      contextId: '<',
      data: '<',
      service: '<',
      onRefresh: '&'
    },
    controller: ntaSectionComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/nta-section/nta-section.component.js